// マイページ → 注文ページ(LP) への引き継ぎ用の値整形ユーティリティ
//
// サイオンの顧客API(api/customers)が返す
//   customer_kana : "ｵｵﾀｶ ﾀｸﾔ"   （半角カナ・姓名スペース区切り）
//   birth_date    : "1969/03/11"   （YYYY/MM/DD）
// を、LP注文フォームの入力欄フォーマットに変換する。
//
// LP側は $arr_form_data['seikana'] 等をそのまま value に出力し、
// year/month/day は set_birth_day() が値一致の option を selected にする。
// そのため seikana/meikana は「全角カタカナ」、year/month/day は
// option の value（先頭ゼロなしの数値文字列。例 month="3", day="11"）で送る必要がある。

/**
 * customer_kana("ｵｵﾀｶ ﾀｸﾔ") を全角カタカナの姓・名に分割する。
 * NFKC正規化で半角カナ→全角カナ（濁点・半濁点・長音も結合）に変換し、
 * 空白（半角/全角）で姓名を分割する。データが無い場合は空文字を返す。
 * @param {string} customerKana
 * @returns {{seikana: string, meikana: string}}
 */
export function splitKana(customerKana) {
  const normalized = (customerKana || "").normalize("NFKC").trim();
  if (!normalized) return { seikana: "", meikana: "" };
  const parts = normalized.split(/\s+/);
  return { seikana: parts[0] || "", meikana: parts[1] || "" };
}

/**
 * birth_date("1969/03/11") を LP の year/month/day セレクト値に分割する。
 * month/day は option の value に合わせて先頭ゼロを除去する（"03"→"3"）。
 * 未設定・0埋め(0000/00/00)・不正形式の場合は空文字を返す（既存挙動と同じ＝未選択）。
 * @param {string} birthDate
 * @returns {{year: string, month: string, day: string}}
 */
export function splitBirthDate(birthDate) {
  const empty = { year: "", month: "", day: "" };
  if (!birthDate) return empty;
  const m = String(birthDate).match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
  if (!m) return empty;
  if (m[1] === "0000" || parseInt(m[2], 10) === 0 || parseInt(m[3], 10) === 0) {
    return empty;
  }
  return {
    year: m[1],
    month: String(parseInt(m[2], 10)),
    day: String(parseInt(m[3], 10)),
  };
}
